import {
    FileText,
    Image as ImageIcon,
    Layers,
    ShieldCheck,
    Timer as TimerIcon,
    QrCode,
    Type as TypeIcon,
    Youtube,
    Gauge,
    Baseline,
    Ruler,
} from 'lucide-react';

export const CATEGORIES = [
    { id: 'file', label: 'File tools' },
    { id: 'image', label: 'Image tools' },
    { id: 'text', label: 'Text tools' },
    { id: 'utility', label: 'Utility tools' },
    { id: 'seo', label: 'SEO tools' },
];

export const TOOLS = [
    {
        slug: 'word-to-pdf',
        title: 'Word to PDF',
        short: 'Convert .docx and .doc files to clean, portable PDFs.',
        category: 'file',
        icon: FileText,
        badges: ['Server-side', 'Preserves formatting'],
        status: 'live',
    },
    {
        slug: 'jpg-to-png',
        title: 'JPG to PNG',
        short: 'Convert JPG images to PNG with lossless quality.',
        category: 'image',
        icon: ImageIcon,
        badges: ['Lossless', 'Fast'],
        status: 'live',
    },
    {
        slug: 'image-compressor',
        title: 'Image Compressor',
        short: 'Shrink JPG, PNG, or WebP files with a quality slider.',
        category: 'image',
        icon: Layers,
        badges: ['Up to 90% smaller', 'Quality control'],
        status: 'live',
    },
    {
        slug: 'resize-image',
        title: 'Resize Image',
        short: 'Change the dimensions of an image while keeping the aspect ratio.',
        category: 'image',
        icon: Ruler,
        badges: ['Aspect-aware', 'Fast'],
        status: 'live',
    },
    {
        slug: 'word-counter',
        title: 'Word Counter',
        short: 'Count words, characters, sentences, and reading time in real time.',
        category: 'text',
        icon: TypeIcon,
        badges: ['In-browser', 'No upload'],
        status: 'live',
    },
    {
        slug: 'case-converter',
        title: 'Case Converter',
        short: 'Convert text between UPPERCASE, lowercase, Title Case, and more.',
        category: 'text',
        icon: Baseline,
        badges: ['In-browser'],
        status: 'live',
    },
    {
        slug: 'lorem-ipsum',
        title: 'Lorem Ipsum Generator',
        short: 'Generate placeholder text for mockups and design.',
        category: 'text',
        icon: TypeIcon,
        badges: ['In-browser'],
        status: 'live',
    },
    {
        slug: 'timer',
        title: 'Timer',
        short: 'A simple countdown timer and stopwatch that runs in your browser.',
        category: 'utility',
        icon: TimerIcon,
        badges: ['In-browser'],
        status: 'live',
    },
    {
        slug: 'qr-generator',
        title: 'QR Code Generator',
        short: 'Turn any link or text into a scannable QR code, ready to download.',
        category: 'utility',
        icon: QrCode,
        badges: ['In-browser'],
        status: 'live',
    },
    {
        slug: 'thumbnail-downloader',
        title: 'Thumbnail Downloader',
        short: 'Grab high-resolution thumbnails from public YouTube videos.',
        category: 'utility',
        icon: Youtube,
        badges: ['YouTube', 'Fast'],
        status: 'live',
    },
    {
        slug: 'page-speed',
        title: 'Page Speed Checker',
        short: 'Measure the loading performance of any public webpage.',
        category: 'seo',
        icon: Gauge,
        badges: ['SEO', 'Free'],
        status: 'live',
    },
];

export function findTool(slug) {
    return TOOLS.find((t) => t.slug === slug);
}

export function toolsByCategory(catId) {
    if (!catId || catId === 'all') return TOOLS;
    return TOOLS.filter((t) => t.category === catId);
}

export const TRUST_POINTS = [
    { icon: ShieldCheck, text: 'No signup required for any tool' },
    { icon: ShieldCheck, text: 'Files deleted from our servers after processing' },
    { icon: ShieldCheck, text: 'Fast, mobile-friendly, ad-supported — not spammy' },
];
